import { Component, OnInit, DoCheck, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { StepDto } from '../../../../models/StepDTO';
import { NgForm} from '@angular/forms';
import { FileDto } from '../../../../models/FileDto';
import { FileInputComponent } from '../../../file-input/file-input.component';

@Component({
  selector: 'wdm-tag-form',
  styleUrls: ['../../../../styles/components/steps.scss', 'tag-form.component.scss'],
  templateUrl: 'tag-form.component.html',
})

export class TagFormComponent implements OnInit, DoCheck {

  @ViewChild('tagForm', { static: true }) private tagForm: NgForm;
  @ViewChild('stepImage') img: ElementRef;
  @Input() stepInfo: StepDto;
  @Output() errors: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  imageFiles: FileDto[] = [];
  fileInputErrors: boolean;
  @ViewChild(FileInputComponent) fileInputComponent: FileInputComponent;
  isMaxSize = false;

  constructor() {
  }

  ngOnInit() {
    this.imageFiles = this.stepInfo.fileList;
  }

  ngDoCheck(): void {
    if (this.tagForm.status === 'INVALID' || this.fileInputErrors == true) {
      this.errors.emit(true);
    } else {
      this.stepInfo.state = "OK";
      this.errors.emit(false);
    }
  }

  forceValidation() {
    this.tagForm.controls.title.markAsTouched();
    this.tagForm.controls.description.markAsTouched();
  }

  onFileChanges(inputFiles) {
    this.stepInfo.fileList = this.imageFiles;
  }

  hasErrors(hasErrors: boolean): void {
    this.fileInputErrors = hasErrors;
  }
  
}
